var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubShiraz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1667.793 -2136.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M1691.165,2162.1a4.449,4.449,0,0,1-.069,1.411h-1.083a3.832,3.832,0,0,0,.1,1.654l1.432.023.211.962a4.974,4.974,0,0,1-1.416-.052,9.125,9.125,0,0,0-1.078-.147,11.808,11.808,0,0,1-2.615-.724,17.387,17.387,0,0,1-3.624-1.921,14.649,14.649,0,0,1-2.347-1.943,13.215,13.215,0,0,1-2.592-3.907,12.5,12.5,0,0,1-.874-2.855,10.306,10.306,0,0,1-.215-1.784c0-.25-.111-.5-.1-.752a15.768,15.768,0,0,1,.653-4.24,13.6,13.6,0,0,1,.838-2.127,18.6,18.6,0,0,1,1.812-2.73,11.556,11.556,0,0,1,3.709-2.938c.546-.292,1.1-.561,1.656-.842a10.2,10.2,0,0,1,2.483-.8,12.414,12.414,0,0,1,2.477-.348,6.732,6.732,0,0,1,1.049-.037c-.074.051-.142.134-.222.147a15.362,15.362,0,0,0-3.052.769,18.976,18.976,0,0,0-2.9,1.411,13.848,13.848,0,0,0-3.109,2.689,9.1,9.1,0,0,0-1.146,1.6,11.428,11.428,0,0,0-1.37,3.664,10.2,10.2,0,0,0-.1,2.8,10.969,10.969,0,0,0,.6,2.639,13.115,13.115,0,0,0,1.839,3.406,10.368,10.368,0,0,0,2.181,2.24c.395.294.757.633,1.156.919a10,10,0,0,0,2.584,1.309,6.494,6.494,0,0,0,2.888.484A1.41,1.41,0,0,1,1691.165,2162.1Zm-2.514.112a4.794,4.794,0,0,0,.02,1.082c.18,0,.325,0,.47,0s.315-.02.462-.03v-1.051Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M1732.945,2163.039v-1.428H1734V2160c-.165-.128-.375-.047-.569-.061s-.369,0-.611,0l-.433-.228V2159a2.607,2.607,0,0,1,1.074-.044c.538.055,1.067.19,1.6.283a7.1,7.1,0,0,1,1.367.348c.4.157.836.245,1.238.407a18.891,18.891,0,0,1,3.6,1.96,13.672,13.672,0,0,1,2.489,2.246,12.38,12.38,0,0,1,1.909,2.858,16.937,16.937,0,0,1,1.191,3.385c.092.386.047.805.14,1.191a8.858,8.858,0,0,1,.1,1.972,12.218,12.218,0,0,1-.493,3.275,13.771,13.771,0,0,1-2.18,4.5,12.251,12.251,0,0,1-2.176,2.311,16.992,16.992,0,0,1-3.557,2.146,12.434,12.434,0,0,1-2.739.888c-.476.106-.973.122-1.446.238a6.4,6.4,0,0,1-1.253.106,2.354,2.354,0,0,0-.445.114l-.167-.145,2.47-.643a11.751,11.751,0,0,0,2.227-.883,13.068,13.068,0,0,0,2.823-1.865c.345-.3.7-.59,1.022-.917a11.427,11.427,0,0,0,2.882-5.025,7.2,7.2,0,0,0,.289-1.717,12.352,12.352,0,0,0,.082-1.251,12.948,12.948,0,0,0-.861-3.915,13.475,13.475,0,0,0-1.872-3.134,6.99,6.99,0,0,0-1.434-1.49c-.415-.3-.751-.7-1.16-1.01a10.967,10.967,0,0,0-2.25-1.309,14.047,14.047,0,0,0-2.375-.782,2.138,2.138,0,0,0-.43-.059C1733.7,2163.033,1733.354,2163.039,1732.945,2163.039Zm1.435-1.2a3.911,3.911,0,0,0,.031,1.061h.92v-1.061Z",
    transform: "translate(-40.417 -15.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M1758.337,2269.852l.474.025v5.148a.638.638,0,0,0,.609-.2c.112-.272-.022-.489-.052-.719a1.845,1.845,0,0,1,.076-.695l-.232-.8.4-.234.539.239,1.092-.652h.683l.492.25.386.759a4.364,4.364,0,0,1-.061.62,1.424,1.424,0,0,1-.721.977c-1.046.59-2.072,1.216-3.061,1.8h-.987a.856.856,0,0,1-.281-.7c-.03-1.559-.071-3.118-.107-4.677,0-.166,0-.331,0-.556Zm2.391,3.66a.888.888,0,0,0-.739.493l.279.347c.2-.206.526-.092.651-.439Zm1.516-.6a.657.657,0,0,0-.759.194c-.158.137-.181.3-.041.533l.52-.136Z",
    transform: "translate(-58.767 -96.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-2",
    d: "M1735.324,2282.208a.984.984,0,0,1-.524,1.205c-.323.164-.619.383-.929.578l-.243.491c.2.639.557.929,1.09.839a2,2,0,0,0,.6-.251c.559-.308,1.1-.656,1.669-.941a20.94,20.94,0,0,0,1.953-1.1,2.4,2.4,0,0,1,.467-.173l.3.533-.2.645c-.746.429-1.5.874-2.265,1.3-.461.254-.934.491-1.417.7a3.3,3.3,0,0,1-1.484.3.861.861,0,0,1-.739-.4c-.166-.261-.312-.535-.458-.788V2284l.553-1.11a2.369,2.369,0,0,1,1.3-.761A1.086,1.086,0,0,1,1735.324,2282.208Z",
    transform: "translate(-40.967 -104.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M1700.454,2280.975a2.305,2.305,0,0,0-.357.115q-2.319,1.185-4.633,2.379c-.322.165-.648.325-.968.493a.821.821,0,0,1-.968-.135l-.225-.6.153-.279.69.089c.978-.55,2.007-1.138,3.046-1.707.991-.543,1.993-1.068,2.992-1.6a2.129,2.129,0,0,1,.289-.106c.317.206.306.547.436.808l-.428.519Z",
    transform: "translate(-11.945 -103.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M1719.345,2276.833a.774.774,0,0,1,.273.02,1.056,1.056,0,0,0,1.109-.2c.816-.514,1.675-.957,2.511-1.438.551-.317,1.086-.665,1.643-.972.245-.135.479-.36.841-.242v1.07c-1.743,1-3.577,1.9-5.341,2.873h-.685l-.493-.511.117-.578Z",
    transform: "translate(-30.811 -99.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-2",
    d: "M1696.343,2277.338l.292.525a1.1,1.1,0,0,1-.715,1.024c-1.226.612-2.426,1.277-3.636,1.92a.652.652,0,0,1-.1.035h-.668l-.29-.392v-.568a4.909,4.909,0,0,0,2.222-.871c.34-.213.722-.356,1.076-.548a5.4,5.4,0,0,0,1.285-.826A2.594,2.594,0,0,1,1696.343,2277.338Z",
    transform: "translate(-10.432 -101.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M1736.856,2234.75a5.936,5.936,0,0,1,1.549.118v1.2c-.349.3-.765.045-1.175.2l-.046,1.086a5.405,5.405,0,0,1-1.5.06v-1.37c.351-.137.744.008,1.171-.094Z",
    transform: "translate(-42.816 -70.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M1719.554,2157.714v1.144h-1.41v-1.276c.351-.275.763-.044,1.177-.182v-1.139h1.43v1.356C1720.393,2157.751,1720,2157.608,1719.554,2157.714Z",
    transform: "translate(-30.04 -13.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-2",
    d: "M1712.822,2266l.275.2v3.353l-.6.467h-.461v-3.4Z",
    transform: "translate(-25.588 -93.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-2",
    d: "M1729.248,2268.426a.733.733,0,0,1,.246.085c.221.189.428.394.58.537l-.725.822a.974.974,0,0,1-.609-.539l-.611.558a1.76,1.76,0,0,1-.795-.75,1.815,1.815,0,0,1,.774-.734l-.192-.319c.157-.341.513-.441.75-.669l.739.764-.172.232-.041.085Z",
    transform: "translate(-36.733 -94.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-2",
    d: "M1715.351,2292.148l-.606-.565-.6.546c-.42-.08-.441-.541-.715-.665l.731-.788.583.532.429-.4.231-.011.712.647Z",
    transform: "translate(-26.606 -111.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-2",
    d: "M1719.69,2169.725a3.627,3.627,0,0,1,.045-1.336,4.65,4.65,0,0,1,1.443.035,3.64,3.64,0,0,1-.05,1.359A5.165,5.165,0,0,1,1719.69,2169.725Z",
    transform: "translate(-31.138 -22.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-2",
    d: "M1725.392,2164.449a3.29,3.29,0,0,1,.056-1.277h1.333l.056,1.295A2,2,0,0,1,1725.392,2164.449Z",
    transform: "translate(-35.293 -18.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M1716.1,2177.486v-1.267h1.475a7.354,7.354,0,0,1,.061,1.267Z",
    transform: "translate(-28.553 -27.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M1732.787,2233.86a5.441,5.441,0,0,1-.086-1.377h1.422v1.366A4.9,4.9,0,0,1,1732.787,2233.86Z",
    transform: "translate(-40.642 -68.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-2",
    d: "M1739.821,2228.507a3.494,3.494,0,0,1-1.342.046,4.717,4.717,0,0,1-.051-1.381h1.375A4.837,4.837,0,0,1,1739.821,2228.507Z",
    transform: "translate(-44.796 -64.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-2",
    d: "M1725.932,2175.868a1.46,1.46,0,0,1,.014-1.3h1.328c.125.192.051.418.064.63s0,.4,0,.631A8.1,8.1,0,0,1,1725.932,2175.868Z",
    transform: "translate(-35.606 -26.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-2",
    d: "M1733.413,2221.466v1.277h-1.438a2.332,2.332,0,0,1-.019-1.277Z",
    transform: "translate(-40.042 -60.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-2",
    d: "M1743.435,2221.158h-1.294a5.187,5.187,0,0,1-.046-1.284h1.366A2.553,2.553,0,0,1,1743.435,2221.158Z",
    transform: "translate(-47.473 -59.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-2",
    d: "M1743.34,2299.6l.725-.61.764.72-.8.809c-.153-.17-.285-.311-.41-.458S1743.315,2299.843,1743.34,2299.6Z",
    transform: "translate(-48.391 -117.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-2",
    d: "M1706.242,2271.15l.325.389v.328l-.566.4-.511-.263v-.625A.768.768,0,0,1,1706.242,2271.15Z",
    transform: "translate(-20.823 -96.975)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubShiraz);
export default __webpack_public_path__ + "static/media/hubShiraz.741af11f1aa70edff9577bae49298471.svg";
export { ForwardRef as ReactComponent };